import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import { Container, SKIP_LINK_TARGETS, Row, Col } from '@mirohq-internal/website-ui-foundation';
import { BrandAttributionBlock } from '../brand-attribution-block/brand-attribution-block.esm.js';
import { LanguageSelector } from '../language-selector/language-selector.esm.js';
import { LegalHub } from '../legal-hub/legal-hub.esm.js';
import { AppStoreBadges } from './components/app-store-badges.esm.js';
import { ResponsiveLinkList } from './components/responsive-link-list.esm.js';
import { SocialMediaLinks } from './components/social-media-links.esm.js';

const MiroFooter = ({ items, label, languageSelector, legalHubLinks, socialMediaLinks, ...rest })=>{
    if (!items) {
        return null;
    }
    return jsxs(Container, {
        fluid: true,
        className: "p-0 overflow-hidden pt-xl-600",
        style: {
            backgroundColor: '--section-colors-bg-section-color-4',
            color: '--text-colors-text-alt-text-static-tertiary'
        },
        id: SKIP_LINK_TARGETS.FOOTER_NAVIGATION,
        "data-skip-link": label,
        ...rest,
        children: [
            jsx("div", {
                className: "container container-xl p-0 px-xl-300 ",
                children: jsx(Row, {
                    flexDirection: [
                        'column',
                        'column',
                        'column',
                        'column',
                        'row',
                        'row'
                    ],
                    children: jsx(Col, {
                        className: "d-flex flex-column flex-xl-row gap-xl-300 justify-content-between mb-xl-600",
                        children: items?.map((group)=>{
                            return jsx(React.Fragment, {
                                children: group?.items?.map((item)=>{
                                    return jsx(React.Fragment, {
                                        children: jsx(ResponsiveLinkList, {
                                            label: `${group.label}`,
                                            items: item.items,
                                            showAllLink: item.showAllLink
                                        })
                                    }, JSON.stringify(item.items));
                                })
                            }, JSON.stringify(group.items));
                        })
                    })
                })
            }),
            jsx("hr", {
                className: "d-none d-xl-block"
            }),
            jsx("div", {
                className: "container-xl",
                children: jsxs(Row, {
                    className: "d-flex flex-column align-items-center pt-400 gap-200",
                    children: [
                        jsxs(Col, {
                            className: "d-flex flex-column align-items-center gap-300 flex-md-row justify-content-between",
                            children: [
                                jsxs("span", {
                                    className: "d-flex flex-column flex-md-row gap-300",
                                    children: [
                                        socialMediaLinks && jsx(SocialMediaLinks, {
                                            socialMediaLinks: socialMediaLinks
                                        }),
                                        languageSelector && jsx(LanguageSelector, {
                                            ...languageSelector
                                        })
                                    ]
                                }),
                                jsx(AppStoreBadges, {})
                            ]
                        }),
                        jsxs(Col, {
                            className: "d-flex flex-column align-items-md-baseline align-items-center px-300 px-md-150 pt-200 pb-400 gap-400 flex-md-row justify-content-between justify-content-lg-start",
                            children: [
                                jsx(BrandAttributionBlock, {}),
                                jsx("div", {
                                    className: "d-inline-flex flex-column gap-300 flex-wrap align-items-center flex-md-row",
                                    children: jsx(LegalHub, {
                                        legalHubLinks: legalHubLinks
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

export { MiroFooter };
